export const benefitList = [
    "Szakorvosaink gyors válaszai segítenek eloszlatni egészségeddel kapcsolatos félelmeid, kételyeid, vagy időben útbaigazítanak szükség esetén a megfelelő vizsgálatokra.",
    "Megspórolhatod az utazással és várakozással töltött időt, valamint a személyes szakorvosi vizsgálat díját is, amennyiben nincs szükség rá.",
    "Sok orvosi vizsgálatra akár heteket is várni kell, míg a szakorvosi chat esetében 48 órán belül választ kaphatsz kérdéseidre (átlagos válaszadási idő kevesebb, mint 24 óra)",
];
